<div class="draft-container">
    <mat-icon class="mat-icon" style="cursor: pointer;" (click)="closePopUp()">close</mat-icon>
    <p class="draft-title">Do you want to save <br/> this is a draft</p>
    <div class="button">
        <button id="no-button" (click)="goTo()">No</button>
        <button id="yes-button" (click)="saveAsDraft()">Yes</button>
    </div>
</div>